// extracted by mini-css-extract-plugin
export var childrenContainer = "_4p-0";
export var virtualScrollArea = "_4p-1";